
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecentSearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recentSearches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planYear"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"psxSearchTerm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"psxSearchTerm_en"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pesSearchTerm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pseudoVerticals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pseudoVerticalsArr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"searchType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coverageType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMixedSearchSuggestion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUserTextSearch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"virtualCare"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"specialtyCategories"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bhProgramFacilityAgg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aoeCodes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"behavioralProgramId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":508}};
    doc.loc.source = {"body":"query RecentSearches($planYear: Int, $userId: String) {\n  recentSearches(planYear: $planYear, userId: $userId) {\n    category\n    psxSearchTerm\n    psxSearchTerm_en\n    pesSearchTerm\n    pseudoVerticals\n    pseudoVerticalsArr\n    searchType\n    createdDate\n    location\n    latitude\n    longitude\n    coverageType\n    isMixedSearchSuggestion\n    isUserTextSearch\n    virtualCare\n    gender\n    conditions\n    specialtyCategories\n    bhProgramFacilityAgg\n    aoeCodes\n    behavioralProgramId\n    userId\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["RecentSearches"] = oneQuery(doc, "RecentSearches");
        
